import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { motion } from 'framer-motion';


// const staticTypes = ['NDA/CDA', 'Consulting Agreement'];

const AgreementTypeDropdown = ({ onSelect }) => {
  const [types, setTypes] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAgreementTypes = async () => {
      try {
        const response = await fetch('https://triunityiq.com/api.php/get-agreement-types',{
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }); // Replace with your actual API URL
        const json = await response.json();
        // console.log(json);
        setTypes(json.types); // Assuming response is { types: ['NDA', 'Consulting', ...] }
      } catch (error) {
        console.error('Failed to fetch agreement types:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgreementTypes();
  }, []);

  const handleChange = (e) => {
    // setSelectedType(e.target.value);
    // onSelect(e.target.value);
    const selected = types.find((type) => type.id === e.target.value);
    setSelectedType(selected?.id);
    onSelect({ id: selected?.id, value: selected?.agreement_type });
  };

  return (
    <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel sx={{ color: 'text.primary' }}>Agreement Type</InputLabel>
        <Select
          value={selectedType}
          onChange={handleChange}
          label="Agreement Type"
          sx={{
            borderRadius: 2,
            '& .MuiOutlinedInput-notchedOutline': { borderColor: 'grey.400' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
            backgroundColor: 'background.paper',
          }}
        >
          {types.map((type) => (
            <MenuItem key={type.id} value={type.id}>
              {type.agreement_type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </motion.div>
  );
};

export default AgreementTypeDropdown;